import { createAction, props } from '@ngrx/store';
import { IProducts } from '../models/products.model';

export const loadCurrentProductsFromSomeoneElse = createAction(
  '[CurrentProductsFromSomeoneElse] Load CurrentProductsFromSomeoneElse',
  props<{ request: string }>()
);

export const loadCurrentProductsFromSomeoneElseSuccess = createAction(
  '[CurrentProductsFromSomeoneElse] Load CurrentProductsFromSomeoneElse Success',
  props<{ response: IProducts[] }>()
);

export const loadCurrentProductsFromSomeoneElseFailure = createAction(
  '[CurrentProductsFromSomeoneElse] Load CurrentProductsFromSomeoneElse Failure',
  props<{ error: Error | any }>()
);
